module.exports = __webpack_public_path__ + "static/media/reacto.42c428b8.png";